import { render } from "./template.vue?vue&type=template&id=045a0d40&scoped=true&lang=pug"
const script = {}

import "./template.vue?vue&type=style&index=0&id=045a0d40&lang=less&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-045a0d40"]])

export default __exports__